module.exports = __webpack_public_path__ + "static/media/video_poster.4a653619.png";